// extracted by mini-css-extract-plugin
export var arrows = "_48-6";
export var decrementer = "_48-a";
export var disabled = "_48-4";
export var error = "_48-1";
export var hiddenText = "_48-b";
export var incrementer = "_48-9";
export var input = "_48-8";
export var inputWrapper = "_48-0";
export var leadingIcon = "_48-c";
export var readonly = "_48-3";
export var regular = "_48-7";
export var small = "_48-5";
export var warning = "_48-2";